import { Edge, Node } from 'reactflow';
import { NodesTypes } from '@constants/canvas/general';

export const hideNodesOutsideFocus = (
  nodes: Node[],
  isFocusActive: boolean,
  focusedIds: string[],
): Node[] => {
  if (!isFocusActive) return nodes;

  const focusedSet = new Set(focusedIds);

  return nodes.map((node) =>
    node.type === NodesTypes.CustomNode && !focusedSet.has(node.id)
      ? { ...node, hidden: true }
      : node,
  );
};

export const unselectNodes = (nodes: Node[]): Node[] =>
  nodes.map((node) => (node.selected ? { ...node, selected: false } : node));

export const unselectEdges = (edges: Edge[]): Edge[] =>
  edges.map((edge) =>
    edge.selected ? { ...edge, selected: false, animated: false } : edge,
  );

export const getVisibleNodeIds = (nodes: Node[]): Set<string> =>
  new Set(nodes.filter(({ hidden }) => !hidden).map(({ id }) => id));

export const getExportEntityIds = (nodes: Node[]): string[] =>
  nodes.reduce<string[]>((acc, { id, hidden, type }) => {
    if (!hidden && type === NodesTypes.CustomNode) acc.push(id);

    return acc;
  }, []);
